import React from "react";
import "./App.scss";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import routes from "./Routing/Routes.jsx";
import branch from "branch-sdk";

function App() {
  branch.init(
    "key_live_cyjvLu4fd5zvbeXW4K55MnknzsnsTHF1",
    function (err, data) {
      console.log("INIT", err, data);
    }
  );
  branch.data(function (err, data) {
    console.log("DATA", err, data);
  });

  // To read first data, call `first()` method
  branch.first(function (err, data) {
    console.log("FIRST", err, data);
  });
  const router = createBrowserRouter([
    {
      path: "/",
      children: routes,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
